import React from 'react';
import imageOnError from '../helpers/imgOnError.js';

interface DomainIconProps {
    domain: string;
}

export default function DomainIcon({ domain }: DomainIconProps) {
    return (
        <img 
            src={`https://www.google.com/s2/favicons?domain=${domain}`} 
            onError={imageOnError}
            width="16"
            height="16"
        />
    )
}